export const CAS_PG = 'cas.pg';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/provider.constants.ts